var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"questionnaire-voting"},[_c('div',{staticClass:"inner-content"},[_c('Alert'),_c('Questionnaire',{attrs:{"id":this.$route.params.id}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }